import { action, observable, computed, makeObservable } from 'mobx';
import uniq from 'lodash.uniq';
import { AxiosError } from 'axios';

import { Constructor } from 'jsx/mixins/types';

const Errorable = <T extends Constructor>(superclass: T) => {
  class ErrorableClass extends superclass {
    constructor(...args: any[]) {
      super(...args);
      makeObservable(this);
    }

    @observable
    errors: string[] = [];

    @computed
    get hasErrors() {
      return !!this.errors.length;
    }

    @action
    clearErrors = () => {
      this.errors = [];
    };

    @action
    handleErrorResponse = (
      response: AxiosError<{ errors: Record<string, string[]> }>,
    ) => {
      const serverErrors = response.response?.data.errors || {};

      Object.values(serverErrors).forEach(this.addError);

      return Promise.reject(response);
    };

    @action
    addError = (error: string | string[]) => {
      const errorsCopy = Array.isArray(error)
        ? [...this.errors, ...error]
        : [...this.errors, error];

      this.errors = uniq(errorsCopy);
    };
  }

  return ErrorableClass;
};

export default Errorable;
